/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */

import React from 'react';
import PropTypes from 'prop-types'
import { Dropdown } from '@paypalcorp/pp-react'

class PhoneType extends React.Component {
	constructor(props) {
		super();
		const { defaultNumber: { type = 'Mobile' } = {} } = props
		this.state = {
			type: type,
			phoneTypeErrorMessage: '',
			showIsRequiredError: false
		};
	}

	handleChange = (event) => {
		let value = event.target.value;
		this.setState({ type: value });
		this.props.changePhoneType(value);
		return value
	}

	render() {
		const { errorMessage } = this.props
		const {
			phoneType: label,
			phoneTypeMobile: labelMobile,
			phoneTypeHome: labelHome,
			phoneTypeWork: labelWork
		} = this.props.guestLabels;
		let { phoneTypeErrorMessage } = this.state;

		return (
			<div style={{ margin: '0 0 10px' }}>
				<Dropdown
					id="phoneTypeSelection"
					value={this.state.type}
					onChange={this.handleChange}
					label={label}
					placeholder=""
					options={[
						{ label: 'Mobile', value: labelMobile },
						{ label: 'Home', value: labelHome },
						{ label: 'Work', value: labelWork }
					]}
					errorText={errorMessage || phoneTypeErrorMessage}
				/>
			</div>
		)
	}
}

PhoneType.propTypes = {
	changePhoneType: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	guestLabels: PropTypes.object
};

export default PhoneType;
